import React from "react";
import { defineMessages } from "react-intl";
import SelectFormGroup from "assets/scripts/components/common/form/SelectFormGroup/SelectFormGroup";
import { DECEDENT_RELATIONSHIPS_MESSAGES } from "assets/scripts/constants/Constants";
const messages = defineMessages({
    relationshipLabel: {
        id: "forms.decedentRelationship.label",
        defaultMessage: "Relationship to decedent"
    },
    relationshipNullOption: {
        id: "forms.decedentRelationship.nullOption",
        defaultMessage: "Select Your Relationship"
    }
});
const DecedentRelationshipFormGroup = (props) => {
    const options = [
        {
            value: "",
            label: props.nullOption || messages.relationshipNullOption
        },
        {
            value: "Attorney",
            label: DECEDENT_RELATIONSHIPS_MESSAGES.Attorney
        },
        {
            value: "FamilyFriendOther",
            label: DECEDENT_RELATIONSHIPS_MESSAGES.FamilyFriendOther
        }
    ];
    return (<SelectFormGroup {...props} label={props.label || messages.relationshipLabel} options={options}/>);
};
export default DecedentRelationshipFormGroup;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/DecedentRelationshipFormGroup/DecedentRelationshipFormGroup.tsx